<template>
  <div v-if="hasError">
    <KikHeading
      v-if="showHelpfulInfo"
      class="relative mb-md rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
      :level="4"
      :title="errorMessage"
      :description="errorSubMessage"
    />
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useMagnolia } from '~/composables/custom/useMagnolia/useMagnolia';

const hasError = shallowRef(false);
const errorMessage = shallowRef<string>();
const errorSubMessage = shallowRef<string>();
const log = useCustomLogger();
const { atMagnolia } = useMagnolia();

const showHelpfulInfo = computed(() => process.env.NODE_ENV === 'development' || atMagnolia.value);

onErrorCaptured((err, instance, info) => {
  hasError.value = true;
  errorMessage.value = err.message;
  // eslint-disable-next-line no-underscore-dangle
  errorSubMessage.value = `${info} @ ${instance?.$options.__file}`;

  log.error(err);
  return false; // Prevents the error from propagating further
});
</script>
